import { configData } from "../config/config.js";
import Vue from "vue";
import md5 from "js-md5";


var md5Service = {
  enc: function (data) {
    // console.log("join",data.join().replace(",",""));

    let input = configData.merchantCode + configData.agentKey + data.join().replace(/,/g, "");
    // console.log("MD5 = " + input)
    return md5(input);
  },
  encWithoutKey: function (data) {
    let input = data.join().replace(/,/g, "");
    return md5(input);
  },
  detailEnc: function (data) {
    console.log(data)
    let input = configData.merchantCode + configData.agentKey + data;
    return md5(input);
  }
};

export { md5Service };



// WEBPACK FOOTER //
// ./src/service/md5Service.js